import { render, staticRenderFns } from "./OtherDebt.vue?vue&type=template&id=446c7860&scoped=true"
import script from "./OtherDebt.vue?vue&type=script&lang=js"
export * from "./OtherDebt.vue?vue&type=script&lang=js"
import style0 from "./OtherDebt.vue?vue&type=style&index=0&id=446c7860&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446c7860",
  null
  
)

export default component.exports